import { IComboOrServiceItem } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceOrComboTableItem } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { CheckboxUIModelT } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { SearchCriteriaListItem } from "@/Patient/Models/Appointment/SearchCriteriaListItem";
import { IPatientAppointmentModel } from "@/Patient/Models/UI/Appointment/IPatientAppointmentModel";

interface IAppointmentManagement {
    Model: IPatientAppointmentModel;
}

class AppointmentManagement extends React.Component<IAppointmentManagement, any> {
    public render(): JSX.Element {
        if (this.props.Model.get("SearchCriteria") && this.props.Model.get("SearchCriteria").size > 0) {
            var searchCriteriaRender = this.props.Model.get("SearchCriteria").map((searchCriteria: SearchCriteriaListItem, idx: number) => {
                if (searchCriteria.Model.IsFromService === false) {
                    return (
                        <li className="clearfix" key={"__n" + idx}>
                            <span className="red-text glyphicon glyphicon-remove pointer" onClick={() => this.removeDoctorOrService(searchCriteria)} />
                            <strong className="pointer" onClick={() => this.showServiceFinderPanel()}>
                                {searchCriteria.Model.ServiceList != null && searchCriteria.Model.ServiceList.length > 0 && (
                                    <div>
                                        {searchCriteria.Model.EmployeeList[0].Name} &gt; {searchCriteria.Model.ServiceList[0].Name} ({this.props.Model.get("CustomDuration")} min.)
                                    </div>
                                )}
                                {searchCriteria.Model.AnyServiceList != null && searchCriteria.Model.AnyServiceList.length > 0 && (
                                    <div>
                                        {searchCriteria.Model.EmployeeList[0].Name} &gt; {cacheStore.GetString("AnyLabel")} ({this.props.Model.get("CustomDuration")} min.)
                                    </div>
                                )}
                            </strong>
                        </li>
                    );
                }
                if (searchCriteria.Model.IsFromService === true) {
                    return (
                        <li className="clearfix" key={"__n" + idx}>
                            <span className="red-text glyphicon glyphicon-remove pointer" onClick={() => this.removeDoctorOrService(searchCriteria)} />
                            <strong className="pointer" onClick={() => this.showServiceFinderPanel()}>
                                {this.getServiceDisplayName(searchCriteria.Model.ServiceList[0])}
                            </strong>
                        </li>
                    );
                }
            });
        }

        return (
            <div className="">
                <div className="widget-container round-corners-3">
                    <div className="header pointer" onClick={() => this.showServiceFinderPanel()}>
                        <div className="pull-right" onClick={e => e.stopPropagation()}>
                            <a className="" onClick={() => this.onResetClick()}> {cacheStore.GetString("ResetLabel")}</a>
                            <a className="" onClick={() => this.onPlusIconClick()}><span className="glyphicon glyphicon-plus" style={{ color: "#0070d2", margin: "2px 2px 0 15px" }} /></a>
                            <a className="" onClick={() => this.onRepeatIconClick()}><span className="glyphicon glyphicon-repeat" style={{ color: "#0070d2", margin: "2px 2px 0 15px" }} /></a>
                        </div>

                        <label>{cacheStore.GetString("AppointmentMLabel")}</label>
                    </div>
                    <div className="selected-services">
                        <ul>
                            {searchCriteriaRender}
                        </ul>

                    </div>
                    <div className="btns-row" />
                </div>
            </div>
        );
    }

    private getServiceDisplayName(service: CheckboxUIModelT<ServiceOrComboTableItem<IComboOrServiceItem>>): string {
        return cacheStore.ClinicSettings.EnablePatientChartMultiServiceAvailabilitySearch
            ? `${service.Model.Site} - ${service.Name}`
            : service.Name;
    }

    private onResetClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Appointment.ResetClick);
    }

    private showServiceFinderPanel(): void {
        var operation = new LocalEvent(LocalPatientOperations.Appointment.ShowServiceFinder);
        operation.AddItem("preserveValue", true);
        LocalEventDispatcher.dispatch(operation);
    }

    private onPlusIconClick(): void {
        let operation = new LocalEvent(LocalPatientOperations.Appointment.ShowServiceFinder);
        if (cacheStore.ClinicSettings.EnablePatientChartMultiServiceAvailabilitySearch) {
            operation.AddItem("preserveValue", true);
            operation.AddItem("IsAddSequenceService", false);
        }
        else {
            operation.AddItem("preserveValue", false);
            operation.AddItem("IsAddSequenceService", true);
        }
        LocalEventDispatcher.dispatch(operation);
    }

    private onRepeatIconClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Appointment.Reload);
    }

    private removeDoctorOrService(criteria: SearchCriteriaListItem): void {
        var operation = new LocalEvent(LocalPatientOperations.Appointment.Remove_SearchCriteria);
        operation.AddItem("criteria", criteria);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { AppointmentManagement };
